import { BaseSession } from '@/components/settings/security/decorators/BaseSession.js'
import { i18n } from '@/libs/i18n'

class TokenSession extends BaseSession {
  get slotList() {
    const list = [
      i18n.global.t('settings.integrations.sessionCreatedWithToken'),
    ]

    if (this.expiredAt) {
      list.push(
        i18n.global.t('settings.integrations.activeTill', {
          date: this.expiredAt,
        }),
      )
    }

    if (this.updatedAt) {
      list.push(this.updatedAt.fromNow())
    }

    return list
  }
}

export const TokenSessionDecorator = (session) => {
  return new TokenSession(session)
}
